export const legacyPostMessage = (message: any) => {
  console.log("interface: postmessage", message);
  try {
    window.chrome.webview.postMessage(message);
  } catch {
    // swallow postMessage error
    // window.chrome.webview is only available in the desktop app legacy c# webview
  }
};
